import { zeroPad } from '../number';

export default (number) => zeroPad(number, 2);
